import { render, staticRenderFns } from "./bcNavbar.vue?vue&type=template&id=e00243ea&"
import script from "./bcNavbar.vue?vue&type=script&lang=js&"
export * from "./bcNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports